import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Cookies from 'js-cookie';
import { FormHead, FormSubHead } from '../FormHead';
import AppFormInput from '../AppFormInput';
import Button from '../Button';
import Api from '../../api';
import CheckNumericType from '../../functions/CheckNumeric';
import CheckEmailValidation from '../../functions/CheckEmailValidation';
import LoginFunction from '../../functions/LoginFunction';
import Form from '../Form';
import { AdminContext } from '../../context/AdminContext';
import CookieFunction from '../../functions/cookieFunction';
import loginLogo from '../../../../assets/imgs/login/loginLogo.svg';
import findCountryCode from '../../functions/findCountryCode';
import countriesInfo from '../../objects/countryCodes.json';
import CustomSelect from '../Select';
// import Select from '../Select';
// import Select from '../Select';

const Login = ({
  content,
  setShowUsers,
  setLoginModal,
  setForgetPasswordModal,
  setSignUpModal,
}) => {
  const { setLogin, setUserId, isElectron, countries, direction } =
    useContext(AdminContext);
  const [user, setUser] = useState({ mobile: '', password: '' });
  const [showTitle, setShowTitle] = useState(true);
  const [showErrorMobile, setShowErrorMobile] = useState(false);
  const [showErrorPassword, setShowErrorPassword] = useState(false);
  const [showForget, setShowForget] = useState(true);
  const [serverError, setServerError] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [passType, setPassType] = useState('password');
  const [loading, setLoading] = useState(false);
  const [dial_code, setDial_code] = useState('98');
  const [country, setCountry] = useState('IR');
  // const [countries, setCountries] = useState(
  //   countriesInfo.map((v, i) => {
  //     return { ...v, id: i };
  //   })
  // );
  const [showErrorCode, setShowErrorCode] = useState(false);
  // const [code,setCode]= useState('+98')

  const changeUserMobile = (e) => {
    // var reg = /^0+/gi;
    //   if (e.target.value.match(reg)) {
    //       e.target.valie = e.target.value.replace(reg, '');

    //   // if (e.target.value.length == 0 && e.target.value ==  ){
    //   //   return false;
    //  }
    //  else{
    // let value=e.target.value
    // if (/^0/.test(e.target.value)) {
    //    value= value?.replace(/^0/, "")
    // }
    let value = e.target.value;
    // if( value.charAt(0)=='0'){
    //   // value= e.target.value.substring(1,  e.target.value.length);
    //   value=value.replace(/^0/, "")
    // }
    console.log('vvvv', value.replace(/^0/, ''));
    setUser({ ...user, mobile: value.replace(/^0/, '') });
    setServerError('');
    setShowErrorMobile(false);
    //  }
  };
  const changeUserCode = (e) => {
    let value = e.target.value.replace(/\+/g, '');
    if (
      (CheckNumericType(value) == true || value?.trim()?.length == 0) &&
      value?.trim()?.length < 4
    ) {
      setDial_code(value);
      setServerError('');
      setShowErrorCode(false);
    }
  };
  const changeUserPassword = (e) => {
    setShowErrorMobile(false);
    setUser({ ...user, password: e.target.value });
    setServerError('');
    setShowErrorPassword(false);
  };
  const checkMobileNumber = () => {
    let check;
    if (CheckNumericType(user.mobile) == true) {
      check = CheckNumericType(user.mobile);
    } else {
      check = CheckEmailValidation(user.mobile);
    }
    if (check == false) {
      setShowErrorMobile(true);
    }
  };
  const checkMobileCode = () => {
    // if (dial_code != '98' && dial_code != '1') {
    let index = countries?.findIndex(
      (x) => x.dial_code?.replace('+', '') == dial_code
    );
    console.log('err==', index, countries, dial_code);
    if (index == -1) {
      setShowErrorCode(true);
      return true;
    } else {
      setShowErrorCode(false);
      return false;
    }
  };
  const submitFormFunction = (e) => {
    if (dial_code?.trim()?.length == 0) {
      setShowErrorCode(true);
      if (user?.mobile?.trim()?.length == 0) {
        setShowErrorMobile(true);
      }
      if (user?.password?.trim()?.length == 0) {
        setShowErrorPassword(true);
      }
      e.preventDefault();
      return;
    }
    let check;
    e.preventDefault();
    if (CheckNumericType(user.mobile) == true) {
      check = CheckNumericType(user.mobile);
    } else {
      check = CheckEmailValidation(user.mobile);
    }

    if (check == false) {
      setShowErrorMobile(true);
    }
    if (user?.password?.length == 0) {
      setShowErrorPassword(true);
    }
    if (checkMobileCode()) {
      setShowErrorCode(true);
    }
    if (
      check == true &&
      user?.password?.length !== 0 &&
      checkMobileCode() == false
    ) {
      setShowErrorMobile(false);
      setShowErrorPassword(false);
      setLoading(true);
      Api.userLogin({
        username: `${user.mobile}`,
        password: `${user.password}`,
        countryCode: '+' + dial_code,
      })
        .then((res) => {
          CookieFunction(
            'set',
            'ochattToken',
            res.data.response.accessToken,
            () => {
              setLogin(CookieFunction('get', 'ochattToken'));
            }
          );
          CookieFunction('set', 'userAuthOchatt', res.data.response.uuid);
          CookieFunction(
            'set',
            'userAuthOchattId',
            res.data.response.channelId
          );

          // Cookies.set('ochattToken', res.data.response.accessToken, {
          //   expires: 365,
          // });
          // Cookies.set('userAuthOchatt', res.data.response.channelId, {
          //   expires: 365,
          // });

          // setLogin(Cookies.get('ochattToken'));
          // Cookies.remove('fromSignUp');
          // Cookies.set('user', res.data.response.id, {
          //   expires: 365,
          // });
          CookieFunction('remove', 'fromSignUp');
          CookieFunction('set', 'user', res.data.response.id);

          // setUserId(Cookies.get('user'));
          // LoginFunction(true);
          setLoading(false);
          // setLoginModal(false);
          // navigate('/chat');
          window?.location?.reload();
        })
        .catch((err) => {
          if (navigator.onLine) {
            setServerError(err?.response?.data?.message);
          } else {
            setServerError(content.offlineText);
          }
          setLoading(false);
        });
    }
    // }
  };

  const showSignUpFunc = () => {
    setLoginModal(false);
    setForgetPasswordModal(false);
    setSignUpModal(true);
  };
  const showForgetFunc = () => {
    setLoginModal(false);
    setForgetPasswordModal(true);
    setSignUpModal(false);
  };
  const findLocation = () => {
    fetch('http://ip-api.com/json')
      // fetch('http://208.95.112.1/json')
      // fetch('https://ip-get/list')
      // fetch('https://api.ochatt.com/api/v0/ip-get/list')
      .then((res) => res.json())
      .then((response) => {
        console.log('Country: ', response.country, response);
        setCountry(response);
      })
      .catch((data, status) => {
        console.log('Request failed');
      });
  };
  useEffect(() => {
    findLocation();
  }, []);
  useEffect(() => {
    if (country?.countryCode) {
      setDial_code(
        findCountryCode(country?.countryCode, countries) != -1 &&
          findCountryCode(country?.countryCode, countries) != null
          ? findCountryCode(country?.countryCode, countries)
          : '98'
      );
    }
  }, [country]);

  console.log('dial_code', dial_code, country);
  return (
    <div
      className={`loginBackground ${
        isElectron && 'loginBackgroundPadding'
      } relative`}
    >
      <div className={`flex flex-col justify-center items-center  m-auto`}>
        <img
          src={loginLogo}
          width={100}
          height={100}
          className={`makeWhite ${styles.extraMargin}`}
        />
        <p className={`${styles.extraMargin} textWhite`}>{content?.name}</p>
        <div
          className={`flex justify-center items-stretch w-full h-auto py-6 ${styles.flexStyle} loginContent`}
        >
          {/* <div className={`desktop-view`}>
          <div className={styles.mobileSignup}>
            <p className={styles.bottomText}>
              {content?.logn?.toSignup?.description}
            </p>
            <span className={styles.submitItem} onClick={showSignUpFunc}>
              {content?.logn?.toSignup?.button}
            </span>
          </div>
        </div> */}

          <div className={`${styles.formContainer}`}>
            <div>
              <FormSubHead serverError={serverError} />
              <p className={` ${styles.formHeader}`}>{content?.login?.title}</p>
              <p className={`${styles.formTitle} loginDescColor`}>
                {content?.login?.text}
              </p>
              <Form
                onSubmit={submitFormFunction}
                user={user}
                buttonText={content?.login?.formButton}
                extraStyleButton={{
                  marginTop: 'auto',
                  marginBottom: '0',
                  width: '100%',
                }}
                extraButtonClass={styles.formButton}
                loadingU={loading}
              >
                <div
                  className={`flex flex-row justify-between items-center w-full h-auto ltr`}
                >
                  <span style={{ marginTop: 'auto', padding: '0.5em 0' }}>
                    +
                  </span>
                  <AppFormInput
                    targetType="num"
                    // prefix={"+"}
                    onChange={changeUserCode}
                    // inputStyle={styles.inputStyle}
                    showError={showErrorCode}
                    showTitle={showTitle}
                    onBlur={checkMobileCode}
                    title={`${content?.countryCode?.code}`}
                    // error={'note supported'}
                    // placeholder={content?.personalInfoModal?.placeholder}
                    placeholder={`${content?.countryCode?.placeholder}`}
                    // wrapperStyle={styles.wrapper}
                    wrapperStyle={`${styles.wrapper} borderBottom`}
                    className={styles.inputContainerCode}
                    value={dial_code}
                  />
                  <AppFormInput
                    targetType="num"
                    // type='number'
                    onChange={changeUserMobile}
                    inputStyle={styles.inputStyle}
                    showError={showErrorMobile}
                    showTitle={showTitle}
                    onBlur={checkMobileNumber}
                    title={content?.login?.mobile}
                    // error={content?.login?.mobileError}
                    // placeholder={content?.personalInfoModal?.placeholder}
                    placeholder={content?.login?.mobilePlaceHolder}
                    // wrapperStyle={styles.wrapper}
                    wrapperStyle={`${styles.wrapper} borderBottom`}
                    className={`${styles.inputContainerMobile} ${direction}`}
                    value={user?.mobile}
                  />
                </div>
                {showErrorCode && (
                  <p
                    className={`inputError`}
                  >{`${content?.countryCode?.error}`}</p>
                )}
                {showErrorMobile && (
                  <p className={`inputError`}>{content?.login?.mobileError}</p>
                )}
                {showForget == true && (
                  <p
                    className={`${styles.forgetText} preserveWhiteThemeColor cursor-pointer  mr-auto`}
                    onClick={showForgetFunc}
                  >
                    {content.login?.forgetButton}
                  </p>
                )}
                <AppFormInput
                  onChange={changeUserPassword}
                  inputStyle={styles.inputStyle}
                  showError={showErrorPassword}
                  showTtitle={showTitle}
                  // wrapperStyle={styles.wrapper}
                  placeholder={''}
                  wrapperStyle={`${styles.wrapper} borderBottom`}
                  title={content?.login?.password}
                  error={content?.login?.passwordError}
                  type={passType}
                  className={styles.inputContainer}
                />
              </Form>
            </div>
          </div>

          {/* <FormHead
        content={content}
        description={content?.login?.createAccount?.description}
        title={content?.login?.createAccount?.title}
      >
        <Button
          className={`desktop-view ${styles.submitItem} mainTextColor`}
          onClick={showSignUpFunc}
        >
          {content?.login?.createAccount?.button}
        </Button>
      </FormHead> */}
        </div>
        <div
          className={`flex flex-row justify-center items-center w-auto h-auto ${styles.bottomTexts}`}
        >
          <p>{content?.login?.toSignup?.description}</p>
          <p>
            <span
              className={`cursor-pointer linkStyleNoColor`}
              onClick={showSignUpFunc}
            >
              {' '}
              {content?.login?.toSignup?.button}{' '}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
